import classNames from 'classnames'
import { MdOutlineClear } from 'react-icons/md'
import ReactModal from 'react-modal'

import type { PropsWithChildren, ReactElement } from 'react'

import Button from '~/components/Buttons/Button'

import './styles.scss'

export interface Props {
  className?: string
  containerClassName?: string
  contentRef?: (instance: HTMLDivElement) => void
  id?: string
  isOpen: boolean
  onCloseModal: VoidFunction
  overlayRef?: (instance: HTMLDivElement) => void
  shouldCloseOnEsc?: boolean
  shouldCloseOnOverlayClick?: boolean
  timeoutToClose?: number
}

const Modal = ({
  children,
  className,
  containerClassName,
  contentRef,
  id,
  isOpen,
  onCloseModal,
  overlayRef,
  shouldCloseOnEsc = true,
  shouldCloseOnOverlayClick = true,
  timeoutToClose = 0,
}: PropsWithChildren<Props>): ReactElement => (
  <ReactModal
    ariaHideApp={false}
    className={classNames('modal-component', className)}
    closeTimeoutMS={timeoutToClose}
    contentRef={contentRef}
    id={id}
    isOpen={isOpen}
    onRequestClose={onCloseModal}
    overlayClassName="modal-component-overlay"
    overlayRef={overlayRef}
    shouldCloseOnEsc={shouldCloseOnEsc}
    shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    shouldFocusAfterRender={false}
  >
    <div className={classNames('modal-component__container', containerClassName)}>
      <Button className="close-btn" ghost onClick={onCloseModal}>
        <MdOutlineClear color="#626262" size={17} />
      </Button>
      {children}
    </div>
  </ReactModal>
)

export default Modal
